import React, { useState, useContext, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { AppContext, DispatchContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { List, ListItem, ListItemIcon, ListItemText, TextField, MenuItem } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Service from "../services/service";
import * as actions from '../actions/actions';
import { IconButton } from '@material-ui/core';
import { resolveNotificationMessage } from '../helpers/constants';
import AddIcon from "@material-ui/icons/Add";
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import ShareIcon from '@material-ui/icons/Share';


const useStyles = makeStyles((theme) => ({
    root: {
        overflow: "hidden",
        flexDirection: "column",
        display: "flex",
        overflowY: "auto",
        padding: 0,
        width: '100%'
    },
    date_format: {
        padding: "0 !important",
    },
    action_block: {
        textAlign: "center",
        paddingBottom: "10px",
        margin: '0 16px',
        display: 'none'
    },
    text_filed_container: {
        width: '100%'
    },
    button_block: {
        width: '100%',
        display: 'none'
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
    },
    width_80: {
        width: '80%'
    },
    addProject: {
        marginTop: "16px",
        textAlign: "right",
        width: "20%",
        cursor: "Pointer"
    }
}));

export default function ReportPropertiesForm(props) {
    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const { report, validation } = props;
    const isReadOnly = report.Id && (state.activeReport.ReadOnly || !state.activeReport.IsOwner);

    const [propertyData, setPropertyData] = useState({
        date: (report && report.Scheduled && new Date(report.Scheduled)) || new Date(),
        title: (report && report.Name) || '',
        author: (report && report.Author) || '',
        projectid: (report && report.ProjectId) || "",
        comment: (report && report.Comment) || '',
        reportProjectName: (report && report.ReportProjectName) || "",
    });

    // update the local props when report has been updated
    useEffect(() => {
        //alert(JSON.stringify(report));
        resetReport();
    }, [JSON.stringify(report)]);

    const resetReport = () => {
        setPropertyData({
            ...propertyData,
            title: report && report.Name || '',
            date: report && new Date(report.Scheduled) || new Date(),
            author: report && report.Author || '',
            projectid: report && report.ProjectId || "",
            comment: report && report.Comment || '',
        });
    }

    // check Validatation for report form
    const validateFormSubmit = (type, key) => {
        if (type && key) {
            if (report && type === 'Scheduled' && new Date(report[type]).getTime() === new Date(propertyData[key]).getTime()) {
                return false
            }
            if ((report && report[type] === propertyData[key]) || ((!report[type]) && (!propertyData[key]))) {
                return false
            }
        }
        if (!validation) {
            if (!propertyData.date) {
                const toastrAlert = {
                    type: "error",
                    message: s.notificationMessage.dateRequired,
                    status: true
                }
                dispatch(actions.openToast(toastrAlert))
                return false
            }
            if (propertyData.title.trim() === '') {
                const toastrAlert = {
                    type: "error",
                    message: s.notificationMessage.titleRequired,
                    status: true
                }
                dispatch(actions.openToast(toastrAlert))
                return false
            }
        }
        return true
    }

    const resetPropertyData = () => {
        setPropertyData({
            ...propertyData,
            title: (report && report.Name) || '',
            date: (report && new Date(report.Scheduled)) || new Date(),
            author: (report && report.Author) || '',
            projectid: (report && report.ProjectId) || "",
            comment: (report && report.Comment) || '',
        });
    }

    const onConfirmUpdate = (key) => {
        state.selectedReportIds.length && Service.UpdateReports({ ...propertyData, field: key }, state.selectedReportIds, state.ui.permaLinkId).then(res => {
            if (res.success) {
                Service.getReport(report.Id, false, state.ui.permaLinkId).then(res => {
                    dispatch(actions.get_report(res.data || []));
                    dispatch(actions.notifyReportsChanged());
                });
            } else {
                dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
            }
        });
    }

    const onCancelUpdate = () => {
        resetReport();
    }


    // action While Submit report form
    const handleSubmit = (e, type, key) => {
        e.preventDefault();

        // this is a draft report only used in new plag check, no need for update
        if (!report.Id) {
            //alert(JSON.stringify(propertyData));
            dispatch(actions.setDraftReport(propertyData));
            return;
        }

        let validate = validateFormSubmit(type, key);
        if (!validate)
            return;

        if (state.selectedReportIds.length > 1) {
            dispatch(actions.openConfirmationDialog({
                title: s.reportOverview.updateMultiple.format(state.selectedReportIds.length),
                text: s.reportOverview.updateMultipleDesc,
                onConfirm: () => onConfirmUpdate(key),
                onCancel: () => onCancelUpdate(),
                hint: s.reportOverview.updateMultipleHint
            }));
        } else {
            onConfirmUpdate();
        }
    }

    const createProjectPopup = () => {
        dispatch(actions.create_project_popup(true));
    }

    return (

        <div className={classes.root}>
            <form className={classes.form} noValidate autoComplete="off" onSubmit={handleSubmit}>
                {/* List item start */}
                <List>
                    {report.Id ?
                        <ListItem>
                            <div className={classes.text_filed_container}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        disabled={isReadOnly}
                                        required
                                        label={s.date}
                                        autoOk
                                        size="small"
                                        format={s.common.dateFormatJS}
                                        className={`${classes.text_filed_container} ${classes.date_format}`}
                                        value={propertyData.date}
                                        onBlur={(e) => handleSubmit(e, 'Scheduled', 'date')}
                                        onChange={(date) => setPropertyData({ ...propertyData, date: date })}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </ListItem>
                        : ""}
                    <ListItem>
                        {validation ?
                            <div className={classes.text_filed_container}>
                                <TextField
                                    disabled={isReadOnly}
                                    className={classes.text_filed_container}
                                    size="small"
                                    label={s.title}
                                    value={propertyData.title}
                                    onBlur={(e) => handleSubmit(e, 'Name', 'title')}
                                    onChange={(evt) =>
                                        setPropertyData({ ...propertyData, title: evt.target.value })
                                    }
                                />
                            </div> :
                            <div className={classes.text_filed_container}>
                                <TextField
                                    disabled={isReadOnly}
                                    required
                                    className={classes.text_filed_container}
                                    size="small"
                                    label={s.title}
                                    value={propertyData.title}
                                    onBlur={(e) => handleSubmit(e, 'Name', 'title')}
                                    onChange={(evt) =>
                                        setPropertyData({ ...propertyData, title: evt.target.value })
                                    }
                                />
                            </div>}
                    </ListItem>
                    <ListItem>
                        <div className={classes.text_filed_container}>
                            <TextField
                                disabled={isReadOnly}
                                className={classes.text_filed_container}
                                label={s.author}
                                size="small"
                                value={propertyData.author}
                                InputProps={{ endAdornment: "" }}
                                onBlur={(e) => handleSubmit(e, 'Author', 'author')}
                                onChange={(evt) =>
                                    setPropertyData({ ...propertyData, author: evt.target.value })
                                }
                            />
                        </div>
                    </ListItem>
                    {(state.ui.permaLinkId || isReadOnly) ?
                        <ListItem>
                            <div className={classes.text_filed_container}>
                                <TextField
                                    disabled
                                    className={classes.text_filed_container}
                                    label={s.project}
                                    size="small"
                                    value={report.ProjectName || ""}
                                />
                            </div>
                        </ListItem> :
                        <ListItem>
                            <div className={classes.width_80}>
                                <TextField
                                    disabled={isReadOnly}
                                    size="small"
                                    select
                                    className={classes.text_filed_container}
                                    label={s.project}
                                    value={propertyData.projectid > 0 ? propertyData.projectid : ""}
                                    onBlur={(e) => handleSubmit(e, 'ProjectId', 'projectid')}
                                    onChange={(e) =>
                                        setPropertyData({ ...propertyData, projectid: e.target.value })
                                    }>
                                    <MenuItem key={0} value={0}>
                                        [{s.noProject}]
                                    </MenuItem>
                                    {state.projects
                                        .filter(option => option.IsOwner === 1)
                                        .map(option => (
                                            <MenuItem key={option.Id} value={option.Id}>
                                                {option.Name}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </div>
                            <div className={classes.addProject}>
                                <IconButton disabled={isReadOnly || state.ui.permaLinkId} onClick={() => { createProjectPopup(); }}>
                                    <AddIcon />
                                </IconButton>
                            </div>
                        </ListItem>
                    }
                    <ListItem>
                        <div className={classes.text_filed_container}>
                            <TextField
                                disabled={isReadOnly}
                                multiline
                                className={classes.text_filed_container}
                                size="small"
                                label={s.notes}
                                value={propertyData.comment || ""}
                                onBlur={(e) => handleSubmit(e, 'Comment', 'comment')}
                                onChange={(evt) =>
                                    setPropertyData({ ...propertyData, comment: evt.target.value })
                                }
                            />
                        </div>
                    </ListItem>
                </List>
                <Button className={classes.button_block} type="submit" disabled={isReadOnly}>
                    {s.submit}
                </Button>
                {/* List item end */}
            </form>
        </div>
    );
};
